import { BaseService } from "./base.service";

class Service extends BaseService {

}

export const HerbUnitService = new Service('/herb-unit');